<style scoped>
@import '../../assets/css/account.css';
</style>

<template>
<div>
    <div class="main-panel">
        <div class="main-content">
            <div class="container-fluid">
                <form id="editProfileForm" @submit.prevent="editProfile" :submit="editProfile">
                    <b-card :header="$t('admin.table_account_info')" header-tag="header">
                        <b-row>
                            <b-col cols='12'>
                                <b-form-group label-cols="12" label-cols-lg="4">
                                    <template slot="label">{{$t('admin.table_old_password')}}</template>
                                    <b-form-input name="current_password" type="password"></b-form-input>
                                </b-form-group>
                                <b-form-group label-cols="12" label-cols-lg="4">
                                    <template slot="label">{{$t('admin.table_login_password')}}</template>
                                    <b-form-input name="new_password" type="password"></b-form-input>
                                </b-form-group>
                                <b-form-group label-cols="12" label-cols-lg="4">
                                    <template slot="label">{{$t('admin.table_login_password_confirm')}}</template>
                                    <b-form-input name="confirm_new_password" type="password"></b-form-input>
                                </b-form-group>
                                <b-form-group label-cols="12" label-cols-lg="4">
                                    <template slot="label">{{$t('admin.table_old_security')}}</template>
                                    <b-form-input name="current_security_password" type="password"></b-form-input>
                                </b-form-group>
                                <b-form-group label-cols="12" label-cols-lg="4">
                                    <template slot="label">{{$t('admin.table_security')}}</template>
                                    <b-form-input name="new_security_password" type="password"></b-form-input>
                                </b-form-group>
                                <b-form-group label-cols="12" label-cols-lg="4">
                                    <template slot="label">{{$t('admin.table_security_confirm')}}</template>
                                    <b-form-input name="confirm_new_security_password" type="password"></b-form-input>
                                </b-form-group>
                            </b-col>
                        </b-row>
                    </b-card>
                    <b-card class="mt-5">
                        <b-row>
                            <b-col cols='12'>
                                <b-form-group label-cols="12" label-cols-lg="4">
                                    <template slot="label">{{$t('admin.table_my_security')}}</template>
                                    <b-form-input name="security_password" type="password"></b-form-input>
                                </b-form-group>
                            </b-col>
                        </b-row>
                    </b-card>
                    <b-button class="mt-4" variant="primary" block type="submit">{{$t('button.submit')}}</b-button>
                </form>
            </div>
        </div>
    </div>
</div>  
</template>

<script>
import {profileAjaxTable,profileEdit} from '@/system/model/account';
import {removeTokenByName} from '@/system/store/cookie';
import {getSessionStorage,setSessionStorage } from '@/system/store/sessionstorage';
import {setLocalStorage, getLocalStorage} from '@/system/store/localstorage';

export default {
    inject:['preloader'],
    data(){
        return{
            ajaxLoad: false,
        }   
    },methods:{
        initialize(){
            var self = this;
            var result = profileAjaxTable();
            this.preloader(true);
            result.then(function(value){
                self.preloader(false);
                if(value.valid){
                    self.ajaxLoad = true;
                    self.ajaxTable = value.data;
                    self.csrfName = value.data.csrf_list.csrf_name;
                    self.csrfValue = value.data.csrf_list.csrf_value;
                    self.csrfNameKey = value.data.csrf_list.csrf_name_key;
                    self.csrfValueKey = value.data.csrf_list.csrf_value_key;
                }else{
                    self.$swal.fire({
                        type: 'error',
                        html: self.$t('login.error_relogin'),
                        onClose: () => {
                            removeTokenByName('auth_sign_token');
                            self.$router.push('/');
                        }
                    });		
                }
            });
        },editProfile(){
            var self = this;
            var form = document.getElementById('editProfileForm');
            var formData = new FormData(form);
            formData.append(this.csrfNameKey, this.csrfName); 
            formData.append(this.csrfValueKey, this.csrfValue); 
            var result = profileEdit(formData);
            this.preloader(true);
            result.then(function(value){
                self.preloader(false);
                if(value.valid){
                    self.$swal.fire({
                        type: 'success',
                        text: self.$t(value.returnMsg),
                        onClose: () => {
                            self.initialize();
                        }
                    });
                }else{
                    var text = "";
                    if(Array.isArray(value.returnMsg)){
                        value.returnMsg.forEach(function (value) {
                            text += self.$t(value)+"<br />";
                        }); 
                    }else{
                        text = self.$t(value.returnMsg);
                    }

                    self.$swal.fire({
                        type: 'error',
                        html: text,
                        onClose: () => {
                            self.initialize();
                        }
                    });
                }
            });
        }
    },created(){
        this.initialize();
    }
}
</script>
